import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';

import { cn } from '@/shared/ui/cn';
import { CountBadge } from '@/shared/ui/CountBadge';
import { Icon } from '@/shared/ui/Icon';

import { activeKey, isWorkspace, mobileTabs } from '@/app/shell/navigation';
import { useNavBadges } from '@/app/shell/useNavBadges';
import { useAppMode } from '@/stores/session.store';

/**
 * La barre d'onglets du téléphone : les destinations fixes de l'espace, celles
 * du mobile, dans le même ordre. L'onglet actif passe à l'or (place de marché)
 * ou au marine (espaces de travail) et son icône devient pleine : pas
 * d'indicateur, pas de bouton flottant. La barre situe, elle n'attire pas l'œil.
 */
export function BottomTabs() {
  const { t } = useTranslation(['common', 'web', 'account']);
  const mode = useAppMode();
  const { pathname } = useLocation();
  const badges = useNavBadges();
  const tabs = mobileTabs(mode);
  const active = activeKey(mode, pathname);
  const workspace = isWorkspace(mode);

  return (
    <nav
      aria-label={t('web:shell.mainNav')}
      className="safe-bottom fixed inset-x-0 bottom-0 z-30 border-t border-line bg-surface/95 backdrop-blur-md md:hidden"
    >
      <ul className="flex px-1 pt-[7px]">
        {tabs.map((tab) => {
          const current = active === tab.key;
          const badge = tab.badge ? badges[tab.badge] : 0;
          return (
            <li key={tab.key} className="flex-1">
              <Link
                to={tab.to}
                aria-current={current ? 'page' : undefined}
                className="flex flex-col items-center gap-1 pt-0.5 pb-1.5"
              >
                <span className="relative">
                  <Icon
                    name={current ? tab.iconActive : tab.icon}
                    size={24}
                    className={current ? (workspace ? 'text-primary' : 'text-accent') : 'text-fg-faint'}
                  />
                  {badge > 0 ? <CountBadge value={badge} max={9} className="absolute -top-1 -right-2" /> : null}
                </span>
                <span
                  className={cn(
                    'text-micro',
                    current ? (workspace ? 'text-primary-text' : 'text-accent-text') : 'text-fg-faint',
                  )}
                >
                  {t(tab.label)}
                </span>
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
